import popsss from 'lib/popsss';

import { ACTION_TYPES } from '../constants';

// ---------------------------------
// Category related action creators:
// ---------------------------------

export function addCategoryStart() {
  return {
    type: ACTION_TYPES.ADD_CTG_START,
  };
}

export function addCategorySuccessful(category) {
  return {
    type: ACTION_TYPES.ADD_CTG_SUCCESSFUL,
    category,
  };
}

export function addCategoryFailed(error) {
  return {
    type: ACTION_TYPES.ADD_CTG_FAILED,
    error,
  };
}

export function updateCategoryStart(category) {
  return {
    type: ACTION_TYPES.UPDATE_CTG_START,
    category,
  };
}

export function updateCategorySuccessful(category) {
  return {
    type: ACTION_TYPES.UPDATE_CTG_SUCCESSFUL,
    category,
  };
}

export function updateCategoryFailed(category, error) {
  return {
    type: ACTION_TYPES.UPDATE_CTG_FAILED,
    category,
    error,
  };
}

export function deleteCategoryStart(category) {
  return {
    type: ACTION_TYPES.DELETE_CTG_START,
    category,
  };
}

export function deleteCategorySuccessful(category) {
  return {
    type: ACTION_TYPES.DELETE_CTG_SUCCESSFUL,
    category,
  };
}

export function deleteCategoryFailed(category, error) {
  return {
    type: ACTION_TYPES.DELETE_CTG_FAILED,
    category,
    error,
  };
}

// ========================================
// For user inetractions on category level:
// ========================================

export function editCategory(category) {
  return {
    type: ACTION_TYPES.EDIT_CTG,
    category,
  };
}

export function cancelCategoryEdit(category) {
  return {
    type: ACTION_TYPES.CANCEL_CTG_EDIT,
    category,
  };
}

export function expandCategory(category) {
  return {
    type: ACTION_TYPES.EXPAND_CTG,
    category,
  };
}

export function collapseCategory(category) {
  return {
    type: ACTION_TYPES.COLLAPSE_CTG,
    category,
  };
}

export function addCategory() {
  return (dispatch) => {
    dispatch(addCategoryStart());
    return popsss
      .postFormData('/faq/group/add')
      .done((result) => {
        const category = result.group;
        category.questions = [];
        category.edit_perm = result.edit_perm;
        dispatch(addCategorySuccessful(category));
      })
      .fail((error) => {
        dispatch(addCategoryFailed(error));
      });
  };
}

export function deleteCategory(category) {
  return (dispatch) => {
    dispatch(deleteCategoryStart(category));
    return popsss
      .postFormData('/faq/group/delete', { group_id: category.group_id })
      .done(() => {
        dispatch(deleteCategorySuccessful(category));
      })
      .fail((error) => {
        dispatch(deleteCategoryFailed(category, error));
      });
  };
}

export function saveCategoryEdit(category) {
  return (dispatch) => {
    dispatch(updateCategoryStart(category));
    return popsss
      .postFormData('/faq/group/update_title', {
        group_id: category.group_id,
        title_value: category.name,
      })
      .done(() => {
        dispatch(updateCategorySuccessful(category));
        dispatch(cancelCategoryEdit(category));
      })
      .fail((error) => {
        dispatch(updateCategoryFailed(category, error));
      });
  };
}

export function publishCategory(category) {
  return (dispatch) => {
    dispatch(updateCategoryStart(category));
    return popsss
      .postFormData('/faq/group/publish', {
        group_id: category.group_id,
        unpublish: !category.publish,
      })
      .done(() => {
        dispatch(updateCategorySuccessful(category));
      })
      .fail((error) => {
        dispatch(updateCategoryFailed(category, error));
      });
  };
}

export function makeCategoryPublic(category) {
  return (dispatch) => {
    dispatch(updateCategoryStart(category));
    return popsss
      .postFormData('/faq/group/privatise', {
        group_id: category.group_id,
        private: !category.public,
      })
      .done(() => {
        dispatch(updateCategorySuccessful(category));
      })
      .fail((error) => {
        dispatch(updateCategoryFailed(category, error));
      });
  };
}
